import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ShareButtonGroup' })((theme) => ({
  socialGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  left: {
    justifyContent: 'flex-start',
  },
  right: {
    justifyContent: 'flex-end',
  },
  leftSpaced: {
    paddingLeft: theme.spacing(1),
  },
  shareButton: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  contentCopyButtonContainer: {
    paddingBottom: '6px',
  },
  contentCopyButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.light,
  },
  smallButton: {
    width: '32px',
    height: '32px',
  },
  largeButton: {
    width: '50px',
    height: '50px',
  },
}));

export default useStyles;
